import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";

export interface VdaCustomerItem {
    label: string
    customerNumber: string
    id: string
}

class VdaCustomerStore {
    get items(): VdaCustomerItem[] {
        return this._items;
    }

    set items(value: VdaCustomerItem[]) {
        this._items = value;
    }

    private _items: VdaCustomerItem[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async search(query: string): Promise<VdaCustomerItem[]> {
        const response = await catchApi(async () => api.vda.api.findCustomers({query: query}))
        return (response?.data || []).map(item => ({
            label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
            customerNumber: `${item.customerNumber}`,
            id: `${item.customerId}`
        }))
    }

    async init() {
        const response = await catchApi(async () => api.vda.api.findCustomers())
        if (response && response.data) {
            this.items = (response.data || []).map(item => ({
                label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
                customerNumber: `${item.customerNumber}`,
                id: `${item.customerId}`
            }))
        }
    }
}

const vdaCustomerStore = new VdaCustomerStore()

export {
    vdaCustomerStore
}
